import { render, staticRenderFns } from "./salePro.vue?vue&type=template&id=12c786ec&scoped=true&"
import script from "./salePro.vue?vue&type=script&lang=js&"
export * from "./salePro.vue?vue&type=script&lang=js&"
import style0 from "./salePro.vue?vue&type=style&index=0&id=12c786ec&scoped=true&lang=css&"
import style1 from "./salePro.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c786ec",
  null
  
)

export default component.exports